import { useColors } from '../../../kiti/components/theme/_hooks/colors'
import { useEditorState } from '../EditorContext'

const FONT_SIZE_BASE = 18
const SMALL_FONT_SIZE_BASE = 14

export const useLeafStyle = ({ leaf }) => {
  const color = useColors()

  return {
    fontFamily: 'Helvetica',
    color: color.dark1,
    fontWeight: leaf.bold ? '800' : '400',
    fontStyle: leaf.italic ? 'italic' : null,
    textDecoration: leaf.underline ? 'underline' : null,
    align: leaf.align
  }
}

export const useElementStyle = ({ align }) => {
  const { size } = useEditorState()

  return {
    fontSize: size === 'small' ? SMALL_FONT_SIZE_BASE : FONT_SIZE_BASE,
    lineHeight: 1.4,
    textAlign: align
  }
}
